import React from "react";

const Row = ({ label, value, mono }) => (
    <div className="grid grid-cols-12 gap-4 py-3 border-b hairline last:border-b-0">
        <div className="col-span-12 sm:col-span-4">
            <span className="mono-label">{label}</span>
        </div>
        <div className="col-span-12 sm:col-span-8">
            <span
                className={mono ? "mono-data" : ""}
                style={{
                    fontSize: mono ? 13 : 14.5,
                    color: "var(--ink)",
                    fontFamily: mono
                        ? "JetBrains Mono, monospace"
                        : "IBM Plex Sans, sans-serif",
                }}
            >
                {value}
            </span>
        </div>
    </div>
);

export const PatientWallet = ({ wallet }) => {
    if (!wallet) return null;
    const w = wallet;
    const prefs = w.consent_preferences || {};
    const wear = w.wearable_summary || {};
    const q = w.cardiovascular_questionnaire || {};
    const meds = w.medication_context || {};

    return (
        <section className="panel" data-testid="patient-wallet">
            <div className="px-6 sm:px-8 py-5 border-b hairline flex items-center justify-between">
                <div>
                    <p className="mono-label">Step 01 · Patient wallet</p>
                    <h2
                        className="font-serif mt-1"
                        style={{ fontSize: 28, letterSpacing: "-0.01em" }}
                    >
                        Synthetic patient — patient-held custody
                    </h2>
                </div>
                <span className="mono-label hidden sm:inline">
                    Custody · patient_wallet
                </span>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2">
                <div className="px-6 sm:px-8 py-6 lg:border-r hairline">
                    <p className="mono-label mb-3">Identifiers & consent</p>
                    <Row label="Patient ref" value={w.patient_ref} mono />
                    <Row
                        label="Custody holder"
                        value={w.custody_holder}
                        mono
                    />
                    <Row
                        label="Cardio summary → clinician"
                        value={
                            prefs.share_cardio_summary_with_clinician
                                ? "Allowed"
                                : "Withheld"
                        }
                    />
                    <Row
                        label="Questionnaire → clinician"
                        value={
                            prefs.share_questionnaire_summary_with_clinician
                                ? "Allowed"
                                : "Withheld"
                        }
                    />
                    <Row
                        label="Medication → pharmacist"
                        value={
                            prefs.share_medication_context_with_pharmacist
                                ? "Allowed"
                                : "Withheld"
                        }
                    />
                    <Row
                        label="Aggregate → research"
                        value={
                            prefs.share_aggregate_with_research
                                ? "Allowed"
                                : "Withheld"
                        }
                    />
                    <Row
                        label="Coach follow-up"
                        value={prefs.allow_coach_followup ? "Allowed" : "Withheld"}
                    />
                </div>

                <div className="px-6 sm:px-8 py-6">
                    <p className="mono-label mb-3">Bounded evidence summaries</p>
                    <Row label="Wearable source" value={wear.source} mono />
                    <Row label="Window" value={wear.window} />
                    <Row
                        label="Resting pulse"
                        value={wear.resting_pulse_trend}
                    />
                    <Row label="Systolic trend" value={wear.systolic_trend} />
                    <Row label="Activity" value={wear.activity_trend} />
                    <Row
                        label="Questionnaire"
                        value={`${q.instrument_ref} · band: ${q.score_band}`}
                        mono
                    />
                    <Row
                        label="Medication context"
                        value={`polypharmacy ${meds.polypharmacy_count} · ${(
                            meds.cardio_relevant_classes || []
                        ).join(", ")}`}
                    />
                    <Row
                        label="Interaction flags"
                        value={(meds.interaction_flags || []).join(", ") || "none"}
                    />
                </div>
            </div>

            <div className="px-6 sm:px-8 py-4 border-t hairline panel-alt">
                <p className="mono-label">Care network</p>
                <p className="mono-data mt-1">
                    {(w.care_network || []).join("  ·  ")}
                </p>
            </div>
        </section>
    );
};

export default PatientWallet;
